import { FC, useState } from "react";
import { useNavigate } from "react-router-dom";
import { IParticipant } from "../types";
import { FormSingle } from "../components/FormSingle";

export type FormSingleProps = {
  onFormChange: (newParticipant: IParticipant) => void;
};

export const FormSinglePage: FC = () => {
  const [participant, setParticipant] = useState<IParticipant>(
    {} as IParticipant
  );
  const navigate = useNavigate();

  const handleFormChange = (newParticipant: IParticipant) => {
    newParticipant.stayDates = Array.isArray(newParticipant.stayDates)
      ? newParticipant.stayDates
      : [newParticipant.stayDates];
    setParticipant(newParticipant);
  };

  const handleSummaryClick = () => {
    if (!participant.isValid) return;

    navigate("/form-summary", {
      state: {
        summary: {
          participants: [participant],
          organization: {},
          eventId: participant.eventId,
          eventName: participant.eventName,
          feeTypeId: participant.feeTypeId,
        },
      },
    });
  };

  return (
    <>
      <div className="my-5">
        <FormSingle onFormChange={handleFormChange} />
        <div className="py-5 mx-auto max-w-4xl text-right">
          <button
            onClick={handleSummaryClick}
            disabled={!participant.isValid}
            className={`text-white font-bold py-4 px-8 rounded-lg transition ${
              participant.isValid
                ? "bg-green-500 hover:bg-green-600 cursor-pointer"
                : "bg-gray-400 cursor-not-allowed"
            }`}
          >
            Shrnutí
          </button>
        </div>
      </div>
    </>
  );
};
